/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_Allocation_RankInputs */

const en_reference_field_allocation_rank = /** @type {(inputs: Reference_Field_Allocation_RankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allocation rank`)
};

/**
* | output |
* | --- |
* | "Allocation rank" |
*
* @param {Reference_Field_Allocation_RankInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_allocation_rank = /** @type {((inputs?: Reference_Field_Allocation_RankInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_Allocation_RankInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_allocation_rank(inputs)
});